import { watchAddToCartAlgoliaTrackingSaga } from './AddToCart.algolia.tracking.saga';
import {
  watchAddToCartModelTrackingSaga,
  watchAddToCartTrackingSaga,
} from './AddToCart.tracking.saga';

export const TRACKING_SAGAS = [
  watchAddToCartTrackingSaga,
  watchAddToCartAlgoliaTrackingSaga,
  watchAddToCartModelTrackingSaga,
];
